export const environment = {
	production: true,
  appKey: 'Grip_PenTest',
	apiUrl: 'https://grip-stg.lan.pwc.com/API.Gateway/api',
	accessTokenType:"id_token" ,
  applicationId: 3,
  tenantId: 0,
  auth: {
      authority: 'https://dev-247992.oktapreview.com/oauth2/default',
      client_id: '0oaolptl8kUmQLcLB0h7',
      redirect_uri: 'https://grip-stg.lan.pwc.com/auth-callback',
      post_logout_redirect_uri: 'https://grip-stg.lan.pwc.com/logout-callback',
    response_type: "code",
    scope: "openid profile email",
    filterProtocolClaims: true,
    loadUserInfo: false
  },
  languages: [
    'es.ts',
    'en.ts'
  ]
};
